import { render, staticRenderFns } from "./CareDetail.vue?vue&type=template&id=3777efdc&scoped=true"
import script from "./CareDetail.vue?vue&type=script&lang=js"
export * from "./CareDetail.vue?vue&type=script&lang=js"
import style0 from "./CareDetail.vue?vue&type=style&index=0&id=3777efdc&prod&lang=less&scoped=true"
import style1 from "./CareDetail.vue?vue&type=style&index=1&id=3777efdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3777efdc",
  null
  
)

export default component.exports